import { DateCondition, RuleApplySignType, RuleConditionType } from "@/types/rule.types.ts";
import { z } from "zod";

export const ruleFieldSchema = () =>
  z.object({
    condition_type: z.enum(RuleConditionType),
    sign: z.enum(RuleApplySignType),
    condition_ids: z.array(z.union([z.number(), z.string()])),
    value_ids: z.array(z.union([z.number(), z.string()])),
    condition_entities: z.array(z.unknown()).optional(),
    value_entities: z.array(z.unknown()).optional(),
    date_condition: z.custom<DateCondition>().optional(),
  });

export const ruleGroupsSchema = () => z.array(z.object({ rules: z.array(ruleFieldSchema()) }));
